import { render } from "./nticket.vue?vue&type=template&id=55012d7e"
import script from "./nticket.vue?vue&type=script&lang=ts"
export * from "./nticket.vue?vue&type=script&lang=ts"

import "./nticket.vue?vue&type=style&index=0&id=55012d7e&lang=css"
script.render = render

export default script